import React from 'react'
import { Box, Stack, Typography } from "@mui/material"
import CalificacionA from '../../images/escudos_alto.svg'
import CalificacionB from '../../images/escudos_medio_alto.svg'
import CalificacionC from '../../images/escudos_medio_bajo.svg'
import CalificacionD from '../../images/escudos_bajo.svg'
import colors from '../../theme/colors'
import { t } from 'i18next'
import { useColors } from '../../hooks/useColors'

export const CalificationWithImageAndText = ({ calification, width }) => {

    const { getCalificationColor } = useColors()
    let calificationImage
    let textCalificationImage
    let colorCalificationImage
    
    switch (calification) {
        case "A":
            calificationImage = CalificacionA
            textCalificationImage = "cuestion.LeyendaTextoA"
            colorCalificationImage = "cuestion.LeyendaEtapaA"
            break;
        case "B":
            calificationImage = CalificacionB
            textCalificationImage = "cuestion.LeyendaTextoB"
            colorCalificationImage = "cuestion.LeyendaEtapaB"
            break;
        case "C":
            calificationImage = CalificacionC
            textCalificationImage = "cuestion.LeyendaTextoC"
            colorCalificationImage = "cuestion.LeyendaEtapaC"
            break;
        case "D":
            calificationImage = CalificacionD
            textCalificationImage = "cuestion.LeyendaTextoD"
            colorCalificationImage = "cuestion.LeyendaEtapaD"
            break;
    }

    return (
        <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
        >
            <Typography
                variant='parrafo'
                fontWeight={"bold"}
                color={
                    getCalificationColor(t(colorCalificationImage))
                }
                textAlign='right'>
                {t(textCalificationImage)}
            </Typography>
            <Box component={'img'} width={width} height={'auto'} src={calificationImage} alt={calificationImage} />
        </Stack>
    )
}
